function num(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class ChatConversacionDto {
    public id: number = 0;
    public idCliente: number = 0;
    public titulo: string = "";
    public datecreated: string = "";
    public dateupdated: string = "";

    constructor(data?: any) {
        if (!data) { return; }
        this.id          = num(data.Id,         data.id);
        this.idCliente   = num(data.Id_cliente, data.id_cliente);
        this.titulo      = data.Titulo      || data.titulo      || "";
        this.datecreated = data.Datecreated || data.datecreated || "";
        this.dateupdated = data.Dateupdated || data.dateupdated || "";
    }
}
